import React from "react";

export default class LocationRow extends React.PureComponent {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    const { RowData, setDataEdit } = this.props;
    setDataEdit(RowData);
  }

  render() {
    const { RowData } = this.props;

    return (
      <tr>
        <td>{RowData.Name}</td>
        <td>{RowData.Description}</td>
        <td>
          {RowData.Contact.Name}
          <div className="small text-muted">
            email:&nbsp;
            <a
              href={"mailto:" + RowData.Contact.Email + "?Subject=Hello"}
              target="_top"
            >
              {RowData.Contact.Email}
            </a>
          </div>
        </td>
        <td>{RowData.Site.Name}</td>
        <td>
          <span
            className={`badge${
              RowData.Deleted ? " badge-danger" : " badge-success"
            }`}
            style={{ padding: "6px 8px", borderRadius: "4px" }}
          >
            {RowData.Deleted ? "deleted" : "active"}
          </span>
        </td>
        <td className="text-center">
          <button
            className="btn btn-4r btn-sm btn-primary"
            onClick={() => this.openModal("modal_update")}
          >
            <i className="icon-pencil" />
          </button>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/location/location/helper/component/LocationRow.js